import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MenuSectionItem from './menu-section-item';
import UnstyledHeading from '@components/shared/unstyled-heading';
import { verifyPermissions } from '@utils/permission-utils';
import './menu-section.scss';

const MenuSection = ({ section: { console: consoleVersion, items, permissions, title } }) => {
  // TODO: remove this guard once the old admin console is retired
  if (consoleVersion === 'new') {
    return null;
  }

  if (!verifyPermissions(permissions)) {
    return null;
  }

  return (
    <Fragment>
      <UnstyledHeading rank={3} styleName="menu-title">{title}</UnstyledHeading>
      {items.map(item => <MenuSectionItem key={item.label} item={item} />)}
    </Fragment>
  );
};

MenuSection.propTypes = {
  section: PropTypes.object
};

export default MenuSection;
